import { render, staticRenderFns } from "./Discovers.vue?vue&type=template&id=9103828c"
import script from "./Discovers.vue?vue&type=script&lang=js"
export * from "./Discovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports